import styled from "styled-components"

import IconUI from "@irati/ui/src/Icon"

import ButtonRouterLinkUI from "../ButtonRouterLink"

export const ButtonRouterLink = styled(ButtonRouterLinkUI)`
  .button-router-link-child-wrapper {
    display: inline-flex;
    align-items: center;
  }
`

interface IconProps {
  hasChildren?: boolean
}
export const Icon = styled(IconUI)<IconProps>`
  ${({hasChildren}) => hasChildren && `
    margin-right: 8px;
  `}
`
